export default class FileUploaderService {
  constructor() {
    
  }

  getFileExtension( filename ) {
    let ext = undefined;
    let split = filename.split( '.' );
    if ( split.length > 1 ) { ext = split[ split.length - 1 ]; }
    return ext;
  }

  sanitizeFilename( filename ) {
    let ext = this.getFileExtension( filename );
    if ( ext === undefined ) { ext = ''; }
    filename = filename.replace( `.${ ext }`, `.${ ext.toLowerCase() }` );
    filename = filename.replace( /[^a-z0-9-_.]/gi, '_' ); // Only allow the alphanumeric, dash, underscore, and period characters.
    return filename;
  }
}